import React, { useEffect, useState } from "react";
import SplashPage from "../SplashPage";
import { Button, Col, Container, Row } from "react-bootstrap";
import PrivateApi from "../../services/PrivateApiService";
import { useNavigate, useParams } from "react-router-dom";
import TLineComponent from "../../components/customer/TLineComponent";
import TimelineFilters from "../../components/customer/TimeLineFilters";
import { useQuery } from "react-query";
import { FaBaby } from "react-icons/fa";
import { CiViewTable } from "react-icons/ci";

const HwTimelinePage = () => {

    const API = new PrivateApi();
    const navigate = useNavigate();

    // url parameters
    const { building_id } = useParams();
    const { anlage_id } = useParams();

    // timeline items
    const [items, setItems] = useState([]);

    // selected
    const [selectedAnlage, setSelectedAnlage] = useState(0);
    const [selectedElvs, setSelectedElvs] = useState([]);
    const [historyElvs, setHistoryElvs] = useState([]);
    const [selectedItems, setSelectedItems] = useState([]);

    const [tabData, setTabData] = useState([{id: 1, name:"Aktuell", count: 0, selected: false}, {id: 2, name:"Historisch", count: 0, selected: false}]);


    // API call
    const { data, error, isLoading } = useQuery(
        ["BUILDING_TIMELINE", building_id], 
        () => API.hw_building_timeline(building_id), 
        {staleTime: Infinity}
    );

    useEffect(() => {
        if (data) {
            var tempItems = data.data.poolrechnungen.concat(data.data.abrechnungen).concat(data.data.vorschreibungen);
            if (Array.isArray(tempItems) && tempItems.length > 1) {
                tempItems.sort((a, b) => new Date(a.x_rechnungsdatum ? a.x_rechnungsdatum : a.x_eingangsdatum ? a.x_eingangsdatum : a.create_date) - new Date(b.x_rechnungsdatum ? b.x_rechnungsdatum : b.x_eingangsdatum ? b.x_eingangsdatum : b.create_date)).reverse();
            }
            setItems(tempItems);
    
            if (anlage_id !== undefined) {
                setSelectedAnlage(data.data.anlagen.filter(a => a.x_studio_field_mWMGR === anlage_id)[0].id);
                setSelectedItems(tempItems.filter(i => i.x_anlage_id[0] === selectedAnlage));
            }

            if (data.data.elvs.filter(e => new Date(e.x_datum_vertragsende) > new Date()).length > 0) {
                setTabData(prev => prev.map(tab => tab.name === "Aktuell"? {...tab, count: 1, selected: true}: tab));
            }
            if (data.data.elvs.filter(e => new Date(e.x_datum_vertragsende) < new Date()).length > 0) {
                setTabData(prev => prev.map(tab => tab.name === "Historisch"? {...tab, count: 1}: tab));
            }
        }
    }, [data])


    // when selected anlage changes effect
    useEffect(() => {
        if (data) {
            setSelectedElvs(
                data.data.elvs
                .filter(e => e.x_anlage_id[0] === selectedAnlage && new Date(e.x_datum_vertragsende) > new Date())
                .sort((a, b) => new Date(b.x_belbeg ) - new Date(a.x_belbeg))
            );
            setHistoryElvs(
                data.data.elvs
                .filter(e => e.x_anlage_id[0] === selectedAnlage && new Date(e.x_datum_vertragsende) < new Date())
                .sort((a, b) => new Date(b.x_belbeg ) - new Date(a.x_belbeg))
            );
            setSelectedItems(items.filter(i => i.x_anlage_id[0] === selectedAnlage));
            if (selectedElvs.length > 0) {
                setTabData(prev => prev.map(tab => tab.name === "Aktuell"? {...tab, count: 1, selected: true}: tab));
            }
            if (historyElvs.length > 0) {
                setTabData(prev => prev.map(tab => tab.name === "Historisch"? {...tab, count: 1}: tab));
            }
        }
    }, [selectedAnlage])


    if (isLoading) return <SplashPage />
    if (error) return <SplashPage error={error} />

    if (data) return (
        <Container>
            <Row className="text-start mt-3 mb-5 align-items-center">
                <Col xl="6">
                    <h3>Anlagen im Gebäude bei <span className="text-energo">ENERGO</span> im Zeitverlauf</h3>
                    <p className="text-muted">
                        {data.data.building.name}
                    </p>
                </Col>
                <Col xl="6" className="text-end">
                    <Button onClick={() => navigate(`/hw/dashboard/energieliefervertraege/gebaeude/${building_id}`)} className="btn-energo rounded-pill">
                        <CiViewTable size={25} /> Ansicht: Liste
                    </Button>
                </Col>
            </Row>

            <TimelineFilters anlagen={data.data.anlagen} selected={selectedAnlage} setSelected={setSelectedAnlage} tabData={tabData} setTabData={setTabData} />
            <Container className="mt-3" hidden={tabData[0].selected === false}>
                <Row>
                    <Col>
                        <h4 className="text-energo">Aktuelle Energielieferverträge</h4>
                    </Col>
                </Row>
            </Container>
            <TLineComponent items={selectedItems} elvs={selectedElvs} hidden={tabData[0].selected === false}  />
            <hr className="mt-5" hidden={tabData[0].selected === false} />
            <Container className={tabData[0].selected === false? "mt-5": "mt-3"} hidden={tabData[1].selected === false}>
                <Row>
                    <Col>
                        <h4 className="text-energo">Historische Energielieferverträge</h4>
                    </Col>
                </Row>
            </Container>
            <TLineComponent items={selectedItems} elvs={historyElvs} hidden={tabData[1].selected === false} opaque />

            <Row style={{ marginTop: "100px" }}>
                <Col xl="12" className="text-center">
                    <small className="text-muted">Das ENERGO Managementportal zeigt Ihnen alle Daten ab dem Jahr 2023. Sollten Sie Informationen zu älteren Energielieferverträgen benötigen, kontaktieren Sie uns bitte.</small>
                    <br />
                    <a href="/hw/dashboard/support/" className="link-energo">Support-Bereich</a>
                </Col>
            </Row>

            <Row className="justify-content-center align-items-center" style={{ borderTop: "3px solid #a2c13f", marginTop: "50px" }}>
                <Col xs="5" xl="2" className="mt-5 text-center">
                    <div className="circle-icon border-energo" style={{ marginRight: "0px" }}>
                        <FaBaby className="text-energo" size={50} />
                    </div>
                    <br />
                    <span className="text-energo">Poolbeitritt</span>
                    {data.data.building.x_pool_accession_date !== "False" ?
                        <p>{new Date(data.data.building.x_pool_accession_date).toLocaleDateString('DE-de')}</p>
                        : null
                    }
                </Col>
            </Row>
        </Container>
    )
}

export default HwTimelinePage;